import React, { useState, useEffect } from 'react'
import Header from '../../layout/header'
import Footer from '../../layout/footer'
import Banner from './banner'
import List from './list'
//import List from './listbackup'
import MiddleBanner from './middle-banner'
import { useSelector, useDispatch } from "react-redux";
import { setGetCloudBucketData } from '../../redux/reducers/getCloudBucketSlice';
import { apiCallingPost } from '../../api/services';
import { ToastContainer, toast } from 'react-toastify';
import ListShowAll from './list-show-all'

function Home() {
  const dispatch = useDispatch();
  const { getCloudBucketData } = useSelector((state) => state.getCloudBucketDetails)
  const { showMoreTag,fileType } = useSelector((state) => state.commonData)
  // const [searchText, setSearchText] = useState("");
  // const [fileType, setFileType] = useState("");  
  const { isAuthenticated } = useSelector((state) => state.authentication);
  const { userData } = useSelector((state) => state.masterData);
  const [destinationList, setDestinationList] = useState([])
  const [destListTCount, setDestListTCount] = useState("")
  const [showMore, setShowMore] = useState(false);
  const [videoListFlag, setVideoListFlag] = useState(false);
  const [offset, setOffset] = useState(0);
  const [max, setMax] = useState(12);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [selectedVideoIds, setSelectedVideoIds] = useState([]);

  useEffect(() => {
    bucketDetails()
  }, [])
  useEffect(() => {
    getData("","");
  }, [fileType])
  useEffect(() => {
    if ((!isAuthenticated) || (isAuthenticated && userData?.roleDisplayName == "User")) {
      getData();
    }
    else {
      getData("", "");
    }
  }, []);

  useEffect(() => {
    if ((!isAuthenticated) || (isAuthenticated && userData?.roleDisplayName == "User")) {
      const observer = new IntersectionObserver(
        (entries) => {
          const firstEntry = entries[0];
          if (firstEntry.isIntersecting && hasMore && !loading) {
            const newOffset = offset + max;
            setOffset(newOffset);
            getData(newOffset, max, true);
          }
        },
        { threshold: 1.0 }
      );

      const loadMoreTrigger = document.querySelector("#load-more-trigger");
      if (loadMoreTrigger) {
        observer.observe(loadMoreTrigger);
      }

      return () => {
        if (loadMoreTrigger) {
          observer.unobserve(loadMoreTrigger);
        }
      };
    }
  }, [offset, max, hasMore, loading]);

  const handleTriggerSearch = () => {
    setShowMore(true);
  };

  const bucketDetails = () => {
    apiCallingPost("api/common/getConfigData", {}).then((data) => {

      if (data.data.success === "1") {
        dispatch(setGetCloudBucketData(data.data.result))
      }
    });
  }

  const getData = async (offset = 0, max = 12, isLoadMore = false) => {
    setLoading(true);
    let postData = {};
    let url = "";

    if (isAuthenticated && userData?.roleDisplayName !== "User") {
      postData = {
        userId: "",
        videoName: "",
        fromDate: "",
        toDate: "",
        videoApprovedStatus: "",
        offset: offset,
        max: max,
        file_type_id: fileType
      };
      url = "api/video/videoList";
    } else {
      postData = {
        offset: offset,
        max: max,
        videoNameSearch: "",
        userNameSearch: "",
        fromDate: "",
        toDate: "",
        user_id: userData?.roleDisplayName === "User" ? userData?.userId : "",
        file_type_id: fileType
      };
      url = "api/video/approvedVideoList";
    }
    try {
      const { data } = await apiCallingPost(url, postData);
      if (data.success === "1") {
        let destinationListArray = isAuthenticated && userData?.roleDisplayName !== "User" ? data.dataArray : data.result;
        destinationListArray = destinationListArray.filter(list => list?.videoStatus === "Processed");
        if (userData?.roleDisplayName === "Super_admin" || userData?.roleDisplayName === "APPROVER") {
          destinationListArray = destinationListArray.filter(list => list?.approveStatus !== 'Rejected');
        }
        destinationListArray = destinationListArray.filter(item => {
          if (userData?.roleDisplayName === "Admin") {
            return item.userId == userData.userId || item.approveStatus === "Approved";
          }
          return true;
        });
        setDestinationList((prevList) => isLoadMore ? [...prevList, ...destinationListArray] : destinationListArray);
        setDestListTCount(data.totalCount);
        setHasMore(destinationListArray.length > 0);
      } else {
        setDestinationList([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching destination data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    // <List videoUrl={"https://cdn.jwplayer.com/manifests/pZxWPRg4.m3u8"} />
    <div className={`home-wrapper main-wrapper ${(isAuthenticated && (userData.userDisplayName !== "User")) ? ` main-wrapper-cms` : ``}`}>
      <ToastContainer />
      <Header />
      <Banner isAuthenticated={isAuthenticated} setShowMore={setShowMore} showMore={showMore}
        videoListFlag={videoListFlag} setVideoListFlag={setVideoListFlag} triggerSearch={handleTriggerSearch} />
      <div className={videoListFlag ? 'filter-blur' : ''}>
        {!showMoreTag ?
          <>
            {((!isAuthenticated && destListTCount > 0) ||
              (isAuthenticated &&
                ((userData.roleDisplayName === "User" && destListTCount > 0) ||
                  userData.roleDisplayName === "Admin" ||
                  userData.roleDisplayName === "Super_admin" || userData.roleDisplayName === "APPROVER"))) && (
                <List isAuthenticated={isAuthenticated} userData={userData}
                  destinationList={destinationList.slice(0, 6)} setDestinationList={setDestinationList} destListTCount={destListTCount}
                  getData={getData} getCloudBucketData={getCloudBucketData}
                  selectedVideoIds={selectedVideoIds} setSelectedVideoIds={setSelectedVideoIds} />
              )}
            <MiddleBanner />
            {((!isAuthenticated && destinationList.length > 6) ||
              (isAuthenticated &&
                ((userData.roleDisplayName === "User" && destinationList.length > 6) ||
                  userData.roleDisplayName === "Admin" ||
                  userData.roleDisplayName === "Super_admin" || userData.roleDisplayName === "APPROVER"))) && (
                <List isAuthenticated={isAuthenticated} userData={userData}
                  destinationList={destinationList.slice(6)} setDestinationList={setDestinationList} destListTCount={destListTCount}
                  getData={getData} getCloudBucketData={getCloudBucketData} hasMore={hasMore} loading={loading} shareHide="hide"
                  selectedVideoIds={selectedVideoIds} setSelectedVideoIds={setSelectedVideoIds}
                />
              )}
          </>
          :
          <ListShowAll isAuthenticated={isAuthenticated} userData={userData}
            triggerSearch={handleTriggerSearch} showMore={showMore} />
        }
        <Footer />
      </div>
    </div>
  )
}

export default Home